import {Component, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import {MessageCrudService} from "@evomatik/evk-common";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
    selector: 'lib-req-dialog',
    templateUrl: './req-dialog.component.html',
    styleUrls: ['./req-dialog.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class ReqDialogComponent implements OnInit {

    nombre = '';
    email = '';
    curp = '';
    rfc = '';
    error = 'Información incorrecta';

    constructor(
        public messageCrudService: MessageCrudService,
        public dialogRef: MatDialogRef<ReqDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    )
    {
        this.nombre = data.nombre ? decodeURIComponent(escape(data.nombre)) : this.error;
        this.email = data.email ? data.email : this.error;
        this.curp = data.curp ? data.curp : this.error;
        this.rfc = data.rfc ? data.rfc : this.error;
    }

    ngOnInit(): void {
    }

    save() {
        const confirmDialog = this.messageCrudService.openConfirmDialog({
            warn: '¿La información proporcionada es válida?',
            goonbtn: 'Aceptar'
        });
        confirmDialog.componentInstance.resolveEvent.subscribe(() => {
            this.dialogRef.close(true);
            confirmDialog.close();
        });
    }

}
